// src/app/features/dashboard/admin/stats/TaxReturnIndividualBusinessStats.tsx
import { IGetaxReturnStatsResponse } from 'app/services/projects';
import PieChartStats from './PieChartStats';

const COLORS = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#DC3545',
  '#93C572',
];

interface ITaxReturnIndividualBusinessStats {
  data: IGetaxReturnStatsResponse;
}

const TaxReturnIndividualBusinessStats = ({
  data,
}: ITaxReturnIndividualBusinessStats) => {
  const individualCount = data.tax_returns_stats.businesses_tax_returns_count;
  const businessCount = data.tax_returns_stats.individual_tax_returns_count;
  const totalCount = data.tax_returns_stats.total_tax_returns_count;

  return (
    <PieChartStats
      data={[
        {
          name: 'Individual',
          value: individualCount,
          // override default percentage label with the raw count
          label: <>{individualCount}</>,
        },
        {
          name: 'Business',
          value: businessCount,
          label: <>{businessCount}</>,
        },
      ]}
      total={totalCount}
      colors={COLORS.slice(2, 4)}
    />
  );
};

export default TaxReturnIndividualBusinessStats;
